import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import Chatbot from './Chatbot';
import BookingModal from './BookingModal';

/**
 * Layout component that wraps public pages with Header, Footer, and Chatbot
 * Use this for all public-facing pages to maintain consistent navigation
 */
const Layout = ({ children, showBookingCTA = true }) => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const handleBookingClick = () => {
    setIsBookingModalOpen(true);
  };

  const handleBookingClose = () => {
    setIsBookingModalOpen(false);
  };

  return (
    <>
      <Header onBookingClick={showBookingCTA ? handleBookingClick : undefined} />
      <main>{children}</main>
      <Footer />
      <BookingModal isOpen={isBookingModalOpen} onClose={handleBookingClose} />
      <Chatbot />
    </>
  );
};

export default Layout;
